export default __webpack_public_path__ + "static/media/closing_photo.4b49d649.jpg";